exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mega-one---1HIfB{width:400px!important}.mega-one-span---8nXmv{width:100%!important}.main-menu-area---Xn83M{margin-bottom:10px}.main-menu-area-box-left---1nJxL{text-align:center}.main-menu-area-box-left-img---23CVu{max-height:50px}.main-menu-area-box-right---3K6cz{height:50px;border:1px solid #7596bf;background:#7496bf;border-radius:10px;margin-top:4px;font-size:.9vw;line-height:50px;color:#fff}", ""]);

// exports
exports.locals = {
	"mega-one": "mega-one---1HIfB",
	"mega-one-span": "mega-one-span---8nXmv",
	"main-menu-area": "main-menu-area---Xn83M",
	"main-menu-area-box-left": "main-menu-area-box-left---1nJxL",
	"main-menu-area-box-left-img": "main-menu-area-box-left-img---23CVu",
	"main-menu-area-box-right": "main-menu-area-box-right---3K6cz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1&modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader!./~/sass-loader!./~/sass-resources-loader/lib/loader.js!./src/app/directives/header/menu/style.scss
// module id = 360
// module chunks = 0